<div class="modal-header">
  <h4 class="modal-title">
    <i class="ri-robot-2-line me-2 text-primary"></i>{{ 'channel.copilotModelSelectDialog.title' | translate }}
  </h4>
  <button type="button" class="btn-close" [attr.aria-label]="'channel.copilotModelSelectDialog.close' | translate" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-3">{{ 'channel.copilotModelSelectDialog.description' | translate }}</p>

  @if (!providers.length) {
    <div class="alert alert-warning mb-0">
      <i class="ri-error-warning-line me-1"></i>{{ 'channel.copilotModelSelectDialog.noModelsAvailable' | translate }}
    </div>
  } @else {
    <div class="row g-3">

      <!-- Providers (company) -->
      <div class="col-12 col-md-5">
        <h6 class="text-uppercase text-muted mb-2">{{ 'channel.copilotModelSelectDialog.provider' | translate }}</h6>
        <div class="list-group copilot-scroll-list">
          @for (provider of providers; track provider.slug) {
            <button
              type="button"
              class="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
              [class.active]="provider.slug === selectedProvider"
              (click)="selectProvider(provider.slug)">
              <span class="d-flex align-items-center">
                <span class="avatar-xs me-2">
                  @if (provider.slug === freeSlug) {
                    <span class="avatar-title rounded bg-light text-muted">
                      <i class="ri-gift-line"></i>
                    </span>
                  } @else if (!logoFailed.has(provider.slug)) {
                    <span class="avatar-title rounded bg-white border text-dark">
                      <img
                        [src]="logo(provider.slug)"
                        [alt]="provider.label"
                        class="provider-logo"
                        (error)="onLogoError(provider.slug)">
                    </span>
                  } @else {
                    <span class="avatar-title rounded bg-light text-muted">
                      <i class="ri-sparkling-2-line"></i>
                    </span>
                  }
                </span>
                {{ provider.labelKey ? (provider.labelKey | translate) : provider.label }}
              </span>
              <span class="badge rounded-pill bg-light text-muted">{{ provider.models.length }}</span>
            </button>
          }
        </div>
      </div>

      <!-- Models for the selected provider -->
      <div class="col-12 col-md-7">
        <h6 class="text-uppercase text-muted mb-2">{{ 'channel.copilotModelSelectDialog.availableModels' | translate }}</h6>
        @if (freeSelected) {
          <div class="alert alert-info py-2 mb-2" role="alert">
            <i class="ri-information-line me-1"></i>{{ 'channel.copilotModelSelectDialog.freeNotice' | translate }}
          </div>
        }
        <div class="list-group copilot-scroll-list">
          @for (model of currentModels; track model.id) {
            <button
              type="button"
              class="list-group-item list-group-item-action d-flex align-items-center"
              [class.active]="model.id === selectedModelId"
              (click)="selectModel(model.id)">
              <i class="ri-checkbox-circle-line me-2" [class.invisible]="model.id !== selectedModelId"></i>
              <span class="text-truncate">{{ label(model) }}</span>
              @if (model.free) {
                <small class="text-muted ms-2 text-nowrap">{{ creator(model) }}</small>
              }
            </button>
          } @empty {
            <div class="text-muted small p-2">{{ 'channel.copilotModelSelectDialog.noModelsForProvider' | translate }}</div>
          }
        </div>
      </div>

    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()">{{ 'channel.copilotModelSelectDialog.cancel' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!selectedModelId">
    {{ 'channel.copilotModelSelectDialog.selectModel' | translate }}
  </button>
</div>
